export enum SemitrailersSort {
    CARRIER_NAME_ASC = 'carrierName',
    NAME_ASC = 'name',
    LICENSE_PLATE_ASC = 'licensePlate',
    EXTERNAL_ID_ASC = 'externalId',
    BODY_TYPE_ASC = 'bodyType',
    CARGO_TYPE_ASC = 'cargoType',
    MAKE_ASC = 'make',
    MODEL_ASC = 'model',
    YEAR_ASC = 'year',
    VIN_ASC = 'vin',
    AXLES_ASC = 'axles',
    SUSPENSION_TYPE_ASC = 'suspensionType',
    TIRE_TYPE_ASC = 'tireType',
    KING_PIN_ASC = 'kingPin',
    CARRIER_NAME_DESC = '-carrierName',
    NAME_DESC = '-name',
    LICENSE_PLATE_DESC = '-licensePlate',
    EXTERNAL_ID_DESC = '-externalId',
    BODY_TYPE_DESC = '-bodyType',
    CARGO_TYPE_DESC = '-cargoType',
    MAKE_DESC = '-make',
    MODEL_DESC = '-model',
    YEAR_DESC = '-year',
    VIN_DESC = '-vin',
    AXLES_DESC = '-axles',
    SUSPENSION_TYPE_DESC = '-suspensionType',
    TIRE_TYPE_DESC = '-tireType',
    KING_PIN_DESC = '-kingPin',
}
